import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/communicationmoduleactions.js'
import { FileUpload } from "../../../components/FileUpload.jsx"
import * as appActions from '../../../actions/appactions';
import * as appConstants from '../../../overrides/appconstants.js'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import communicationmoduleservice from '../services/communicationmoduleservice.js';

export default function CommunicationDocumentsUpload() {

    const { register: registerDocuments, handleSubmit: handleDocuments, reset, setValue: setDocuments, formState: { errors: errorDocuments }, clearErrors } = useForm();
    const state = useSelector(state => state.communicationModuleReducer);
    const dispatch = useDispatch();
    let navigate = useNavigate();
    let distinctId = state?.userEntryDetails.mcId;
    let userEntryDetails = state?.userEntryDetails;
    let documents = state?.communicationDocuments;
    let userEntry = state?.userEntry;
        let masters = state?.masters;
 useEffect(() => {
        try {
            //dispatch(actions.getCommunicationDocuments(7/*state?.userEntryDetails.mcId*/, state?.userEntry.linkId));
        } catch (error) {
           
        }
    }, []);

    const onFileChange = (e, srlno) => {
        if (e.fileName && e.fileType) {
            const docIdEncrypted = e.docIdEncrypted;
            const type = e.fileType;
            const field = "fileInput";
            const name = e.fileName;
            const date = new Date();
            let id = e.id.match(/\d+/g);
            id = id[0] - 1;
            // id = id[0];
            const intimationId = state?.userEntryDetails.mcId;//lpoMasterEntry?.lpoMasterId;
   

            dispatch(actions.updateFileChange({ id, field, name, docIdEncrypted, type, date, intimationId, srlno }));
        }
    };

    const handleDocumentChange = (e, srlNo, name) => {
        var { value, checked } = e.target;
   
   dispatch(actions.updateCommunicationDocumentParams({ srlNo, name, value }));
    }

    const handleDocumentCheckboxChange = (e, srlNo) => {
        //dispatch(actions.addSelectedDocuments(srlNo));
    }

    const onSubmitDocuments = async (e) => {
        await dispatch(actions.saveCommunicationDocuments(state?.communicationDocuments?.documentList));
    }

    const onErrorDocuments = (errorDocuments, e) => {
        console.log(errorDocuments);
        console.log(errorDocuments.hasOwnProperty());
    }

    // const onCloseDocuments = (e) => {
    //     reset();
    //     clearErrors();
    //     dispatch(actions.resetDocumentInformation);
    // }

    const onAddNewDocument = async () => {
        await dispatch(actions.addNewCommunicationDocument());
        //reset();
    }

    const onDeleteDocument = async () => {
        if (documents?.selectedDocuments.length == 0) {
           // await dispatch(appActions.showMessage("Select a Document to be Deleted."));
        }
        else {
          //  await dispatch(actions.deleteDocument(documents?.selectedDocuments));
            // await dispatch(actions.updateDocumentTableId());
        }
        reset();
    }

    function renderDocumentComponents() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-3">
                </ul>
                <div className="collapse show" id="CollapseDocuments">
                    <form onSubmit={handleDocuments(onSubmitDocuments, onErrorDocuments)}>
                        <div className="table-responsive">
                            <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                                <thead>
                                    <tr>
                                        {/* <th></th> */}
                                        {/* <th className="text-center">No.</th> */}
                                        {/* <th className="text-center">User Name</th> */}
                                        <th className="text-center">Document Name / اسم المستند</th>
                                        {/* <th className="text-center">Remarks</th>
                                        <th className="text-center">File Type</th>
                                        <th className="text-center">Uploaded Date</th> */}
                                        <th className="text-center">Upload / تحميل</th>
                                        <th className="text-center">View / عرض</th>
                                    </tr>
                                </thead>
                                {(documents?.documentList?.length > 0) &&
                                    <tbody>
                                        {documents?.documentList?.map((doc, index) => (
                                            <tr key={doc.complaintId}>
                                                {/* <td className="text-center">
                                                    <div className="form-check" id="Check1">
                                                        <input type="checkbox" id={doc.srlNo + " " + distinctId} className="form-check-input"
                                                            checked={doc.isChecked}
                                                            //disabled={doc.isMandatory}
                                                            onChange={value => handleDocumentCheckboxChange(value, doc.srlNo)}
                                                            value={doc.docType}
                                                        />
                                                    </div>
                                                </td> */}
                                                {/* <td className="text-center"> {doc.srlNo}</td> */}
                                                {/* <td> <input className={`form-control fw-bold ${errorDocuments?.[`documentName${doc.srlNo}${distinctId}`] ? 'is-invalid' : ''}`}
                                                    type="text" id={"documentName " + doc.srlNo + " " + distinctId} name='documentName'
                                                    {...registerDocuments(`documentName${doc.srlNo}${distinctId}`, { required: true, onChange: (e) => handleDocumentChange(e, doc.srlNo, "documentName") })}
                                                    value={doc.documentName}
                                                />
                                                </td> */}
{/*<td >
                                                    <select className={`form-select fw-bold ${errorDocuments?.[`documentMasterId${doc.srlNo}${distinctId}`] ? 'is-invalid' : ''}`}
                                                    data-toggle="select2" id={"documentMasterId" + doc.srlNo + " " + distinctId} name='documentMasterId'
                                                    disabled={doc.isMandatory == 'Y'}
                                                      {...registerDocuments(`documentMasterId${doc.srlNo}${distinctId}`, { required: false, onChange: (e) => handleDocumentChange(e, doc.srlNo, "documentMasterId") })}
                                                    value={doc.documentMasterId}>
                                                    <option value=''>--Document Type--</option>
                                                    {masters.documentsMasterList.map((document) => (
                                                        <option value={document.documentId} key={document.documentId}>
                                                            {userEntryDetails.prefLanguage == 'AR' ? document.documentNameAR  : document.documentName  }
                                                        </option>
                                                    ))}
                                                </select>
                                                
                                                    
                      
                                                    </td>*/}
{<td >
                                    
                                                 {
        (
            masters.documentsMasterList.find(
                x => x.documentId == doc.documentMasterId
            )?.[
                userEntryDetails.prefLanguage === 'AR'
                    ? 'documentNameAR'
                    : 'documentName'
            ]
        ) || '-'
    }
                                                    
                      
                                                    </td>}
                                             
                                                {/*<td> <textarea className={`form-control fw-bold ${errorDocuments?.[`remarks${doc.srlNo}${distinctId}`] ? 'is-invalid' : ''}`}
                                                    type="text" id={"remarks " + doc.srlNo + " " + distinctId} name='remarks' maxLength={3999}
                                                    {...registerDocuments(`remarks${doc.srlNo}${distinctId}`, { onChange: (e) => handleDocumentChange(e, doc.srlNo, "remarks") })}
                                                    value={doc.remarks}
                                                />
                                                </td>
                                                <td> <input className='form-control'
                                                    type="text" id={"fileType " + doc.srlNo + " " + distinctId} name='fileType' readOnly={true}
                                                    {...registerDocuments(`fileType${doc.srlNo}${distinctId}`)}
                                                    value={doc.fileType}
                                                />
                                                </td>
                                                <td> <input className='form-control'
                                                    type="text" id={"uploadedDate " + doc.srlNo + " " + distinctId} readOnly={true}
                                                    {...registerDocuments(`uploadedDate${doc.srlNo}${distinctId}`)}
                                                    value={doc.uploadedDate == null ? "" : new Date(doc.uploadedDate).toLocaleString('en-GB')}
                                                />
                                                </td>*/}
                                                <td>
                                                    <FileUpload className={errorDocuments.hasOwnProperty(`fileInput${doc.srlNo}${distinctId}`) ? 'form-control is-invalid' : 'form-control'}
                                                        id={"fileInput " + doc.srlNo + " " + distinctId}
                                                        name={`fileInput${doc.srlNo}${distinctId}`}
                                                        {...registerDocuments(`fileInput${doc.srlNo}${distinctId}`, { required: (true && (doc.fileInput === null || doc.fileInput === "" || doc.fileInput === ''))/*, onChange: (e) => handleDocumentChange(e) */ })}
                                                        onChange={e => onFileChange(e, doc.srlNo)}
                                                        value={doc.fileInput}
                                                        file={doc.fileName}
                                                        hidden={true}
                                                         fileType="TempFile"
                                                         subFolder="CommunicationModule"
                                                      //  disabled={userEntryDetails.isSubmitted !=="Y"}
                                                    />
                                                    <label className={errorDocuments.hasOwnProperty(`fileInput${doc.srlNo}${distinctId}`) ? 'btn btn-light btn-outline-danger' : "btn btn-light btn-outline-secondary"}
                                                        for={"fileInput " + doc.srlNo + " " + distinctId}>Choose File</label>
                                                    <text> {(doc.attachmentPath === null || doc.attachmentPath === "" || doc.attachmentPath === '') ? "No file chosen" : 'File Uploaded'}</text>
                                                </td>
                                                
                                                <td className="text-center">
                                                    <button type="button" id={doc.srlNo} className="btn btn-primary"
                                                        data-bs-container="#tooltip-container2"
                                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="download"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            communicationmoduleservice.downloadFile(userEntryDetails.mcId,doc.documentRefId);
                                                        }}>
                                                        <i className="dripicons-cloud-download"></i></button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                }
                            </table>
                        </div>
                        <div className="row g-2">
                            <div className="mb-1 col-md-4">
                                {documents?.documentList?.length == 0 && <h5 className="alert alert-danger">No Documents Found...</h5>}
                            </div>
                        </div>
                     
                    </form>
                </div>
            </>
        )
    }

    return (
        <div className="content">
            <div className="row">
                <div className="col-12">
                    <div className="card ribbon-box">
                        <div className="card-body">
                            <div className="ribbon ribbon-primary float-start"><i className="dripicons-copy me-1"></i>Upload Documents / تحميل المستندات </div>
                            <div className="btn-group float-end" id="tooltip-container2">
                                <button className="btn btn-light ms-1" type="button" id="collapsableButton"
                                    data-bs-toggle="collapse" data-bs-target="#CollapseDocuments"
                                    aria-expanded="false" aria-controls="CollapseDocuments">
                                    <i className="mdi mdi-arrow-up-down"></i>
                                </button>
                            </div>
                            <div className="btn-group float-end collapse show" id="CollapseDocuments">
                                {/* {checkPermissions.hasAddAttachments && */}
                                { userEntryDetails.isSubmitted !== "Y" && <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom"
                                    title="Add New Document" onClick={() => onAddNewDocument()}>
                                    <i className="dripicons-plus"></i>
                                </button> }
                                {/* } */}
                                {/* {checkPermissions.hasDeleteAttachments && */}
                                {/* <button type="button" className="btn btn-danger" data-bs-container="#tooltip-container2"
                                    data-bs-toggle="tooltip" data-bs-placement="bottom"
                                    title="Delete Document" onClick={() => onDeleteDocument()}>
                                    <i className="dripicons-trash"></i>
                                </button> */}
                                {/* } */}
                            </div>
                            <h5 className="text-primary float-end mt-0"> </h5>
                            <div className="ribbon-content">
                                {renderDocumentComponents()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}